import React from 'react'
import styled from 'styled-components'
import WbSunnyIcon from '@material-ui/icons/WbSunny'

const DayIcon = styled(WbSunnyIcon)`

`

export default DayIcon